import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=db145490&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"
import style0 from "./MyDialog.vue?vue&type=style&index=0&id=db145490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db145490",
  null
  
)

export default component.exports